/* global process*/
/**
 * Helps coordinate action(s) with handlers
 *
 * @module lib/ActionRouter
 */

import isPlainObject from 'lodash/isPlainObject';

import Logger from '../tools/Logger';

// our local logger instance
const log = Logger.child({
  component: 'ActionRouter',
});

/**
 * Convenience method for mapping actions to handlers in the middleware.
 *
 * @param {object} patterns A hash of actions (strings/symbols) and handler method pairs
 * @returns {Function} memoized routing function to be used by middlewares
 */
export default function createActionMapping(patterns = {}) {
  // no side effects or surprises since we don't know if it is frozen
  const map = Object.assign(patterns);
  return function routing(action, store, next) {
    const handler = map[action.type];
    if (handler) {
      if (!isPlainObject(action)) {
        log.error(action, 'Received an action that is not a plain object!');
      }
      return Promise.resolve(handler(action, store, next)).then(() => {
        return next(action);
      });
    }
    return next(action);
  };
}
